import { render, staticRenderFns } from "./AddressSelect.vue?vue&type=template&id=c3493576&scoped=true&"
import script from "./AddressSelect.vue?vue&type=script&lang=js&"
export * from "./AddressSelect.vue?vue&type=script&lang=js&"
import style0 from "./AddressSelect.vue?vue&type=style&index=0&id=c3493576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3493576",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VListItemContent,VListItemSubtitle,VListItemTitle,VSelect})
